// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchFiltersForm_root__0FJ41","searchForm":"SearchFiltersForm_searchForm__G_EFE"};